import CircleCreation from "@/pages/circles/CircleCreation";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const circleCreationSchema = z.object({
  source: z.string().optional(),
});

export const Route = createFileRoute("/circle-creation")({
  component: CircleCreation,
  validateSearch: (search) => circleCreationSchema.parse(search),
});
